import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "description" }
const _hoisted_4 = { class: "select-list" }
const _hoisted_5 = ["src", "alt", "onClick"]
const _hoisted_6 = { class: "tooltip" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("table", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.artifactSetEffects, (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: item }, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_2, _toDisplayString(_ctx.displayName(item.key)), 1)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_3, _toDisplayString(item.value), 1)
              ])
            ], 64))
          }), 128))
        ]),
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredList, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "with-tooltip",
              key: item.key
            }, [
              _createElementVNode("img", {
                class: _normalizeClass('artifact-set' + _ctx.bgImageClass(item) + _ctx.selectedClass(item)),
                src: _ctx.getArtifactIconUrl(item.key, _ctx.cat_id),
                alt: item.key,
                onClick: ($event: any) => (_ctx.$emit('update:artifact-set', item.key))
              }, null, 10, _hoisted_5),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.displayName(item.key)), 1)
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}